import { SVGProps } from 'react';

const FolderSync = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v.5M16 14h-4v-4m0 4 1.535-1.605a5 5 0 0 1 8 1.5M18 18h4v4m0-4-1.535 1.605a5 5 0 0 1-8-1.5"
    />
  </svg>
);
export default FolderSync;
